import { RadiusFilterState } from './store/radius.types';

type hashFunctionType = (currentRadius: RadiusFilterState['currentRadius']) => string;

export const radiusFilterHash: hashFunctionType = (currentRadius) => String(currentRadius.value);
